import { createAction } from '../util/index.js';

export const displaySubmitButtonFrf = createAction(
  'DISPLAY_SUBMIT_BUTTON_FRF',
  requestObject => requestObject
);
export const attachmentFrf = createAction('ATTACHMENT_FRF', requestObject => requestObject);
export const displayClearButtonFrf = createAction('DISPLAY_CLEAR_BUTTON_FRF', requestObject => requestObject);
export const clearFormValueFRF = createAction('CLEAR_FORM_VALUE_FRF', requestObject => requestObject);